import { render, staticRenderFns } from "./Pos_bill_after.vue?vue&type=template&id=00368b8c&scoped=true&"
import script from "./Pos_bill_after.vue?vue&type=script&lang=js&"
export * from "./Pos_bill_after.vue?vue&type=script&lang=js&"
import style0 from "./Pos_bill_after.vue?vue&type=style&index=0&id=00368b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00368b8c",
  null
  
)

export default component.exports